<template>
  <div class="container slider-container">
    <!-- 
        <div class="dashboard__box-col">
          <router-link :to="{name: 'News', params: { id: 32 }}">
          <img class="img" src="../../../assets/img/baner-geberit-pro.jpg">
          </router-link >
        </div> -->
    <div class="row">
      <slick-slider
        v-if="sliders.length"
        ref="SlickSlider"
        :sliders="this.sliders"
      >
      </slick-slider>
    </div>

    <!-- 
        <div class="row">
            <calendar-widget></calendar-widget>
        </div>
         -->
    <div v-if="!user.is_certyficated">
      <div class="certificate-banner">
        <p class="certificate-banner__title">
          ZOSTAŃ CERTYFIKOWANYM INSTALATOREM GEBERIT PRO
        </p>
        <h2 class="certificate-banner__header">
          Skontaktuj się z naszym <br /><b>Doradcą Handlowym</b>
        </h2>
        <!-- <p class="certificate-banner__text">Zbieraj punkty i wymieniaj na nagrody</p> -->
        <router-link
          :to="{ name: 'Rules' }"
          tag="button"
          class="certificate-banner__button"
        >
          Kliknij i dowiedz się więcej &raquo;
        </router-link>
      </div>
    </div>

    <main-box-set-widget></main-box-set-widget>

    <div class="row" v-if="user.user_type_id != 5">
      <webinar-widget></webinar-widget>
    </div>

    <div class="row">
      <contact-widget></contact-widget>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { store } from "@/app/store";
import jQuery from "jquery";
import "slick-carousel/slick/slick.js";
import SlickSlider from "./../slider/SlickSlider.vue";

export default {
  name: "DashboardComponent",
  components: {
    SlickSlider,
  },
  data() {
    return {
      sliders: [],
      pagination: {},
    };
  },
  async beforeRouteEnter(to, from, next) {
    if (!store.state.user.address_id) next("/adres");
    else
      await Vue.axios
        .get("/sliders")
        .then((response) => {
          next((vm) => {
            vm.sliders = response.data.data.sliders;
            vm.pagination = response.data.pagination;
          });
        })
        .catch((error) => {
          console.log(error);
        });
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    if (!this.user || this.user.id != 1) {
      this.$gtag.pageview({
        page_path: "/dashboard",
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/dashboard/DashboardComponent.vue